export default {
    private: false,
    slug: 'nivea',
    promo: 'Nivea cut their marketing spend and bumped up their CTR in one campaign.',
    meta: {
        title: 'Case Study NIVEA',
        description: 'Discover the new way of crowdsourcing brand visual content to get high quality, tailored and legally covered visuals with strong storytelling power to drive social media engagement.',
        ogImage: require('Theme/images/videoCaseStudies/nivea/videoCaseStudy-nivea-og.jpg')
    },
    hero: {
        visible: true,
        title: 'Case Study',
        logo: require('Theme/images/videoCaseStudies/nivea/videoCaseStudy-nivea-logo.png')
    },
    challenge: {
        visible: true,
        title: 'THE CHALLENGE',
        subtitle: 'NIVEA noticed that searching for high-quality visual content on stock image marketplaces has proven to be an ineffective model. Moreover, it didn’t fit their “visual first” marketing strategy. The actual brand-like aesthetics and style were either impossible to find or took to much time gathering the right resources. Plus, photo and video shoots required hefty budgets and a lot of effort on the brand’s side was spent to get mediocre results.',
        video: {
            container: require('Theme/images/videoCaseStudies/videoCaseStudy-challenge-fbMock.png'),
            poster: require('Theme/images/videoCaseStudies/nivea/videoCaseStudy-nivea-challenge-videoPoster.jpg'),
            assets: [{
                src: 'https://videoscdn.foap.com/frontend-static-assets/case-studies/webm_w640-foap-case-study-nivea-2.webm',
                type: 'video/webm'
            }, {
                src: 'https://videoscdn.foap.com/frontend-static-assets/case-studies/mp4_w640-foap-case-study-nivea-2.mp4',
                type: 'video/mp4'
            }]
        },
        footer: 'NIVEA was ready to discover an innovative way to create customized visuals that draw an emotional connection to the brand messaging.',
        float01: require('Theme/images/videoCaseStudies/nivea/videoCaseStudy-nivea-challenge-float01.jpg'),
        sideBg: require('Theme/images/videoCaseStudies/videoCaseStudy-challenge-sideBg.svg'),
    },
    whyUs: {
        visible: true,
        title: 'WHY HAS NIVEA<br />CHOSEN US?',
        elements: [{
            styles: { color: '#623CC9' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-city.svg'),
            title: '3M',
            desc: 'Content creators on the platform'
        }, {
            styles: { color: '#F5A623' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-calendar.svg'),
            title: '41,900',
            desc: 'Visuals created daily'
        }, {
            styles: { color: '#50E3C2' },
            type: '3-cols',
            titleLeft: '43',
            descLeft: 'Female',
            divider: '%',
            dividerIcon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-graph-pie.svg'),
            titleRight: '57',
            descRight: 'Male'
        }, {
            styles: { color: '#4AD2FF' },
            type: '4-cols',
            col1Title: 'Age %:',
            col1Icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-graph-lines.svg'),
            col2Title: '32',
            col2Desc: '18+',
            col3Title: '28',
            col3Desc: '25+',
            col4Title: '19',
            col4Desc: '35+',
        }, {
            styles: { color: '#F5A623' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-rocket.svg'),
            title: '800',
            desc: 'Successful branded Missions launched'
        }, {
            styles: { color: '#623CC9' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-connection.svg'),
            title: '322',
            desc: 'Brands & Agencies crowdsourced content via Foap'
        }, {
            styles: { color: '#50E3C2' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-globe.svg'),
            title: '186',
            desc: 'Countries covered by Foaper'
        }],
        sideBg: require('Theme/images/videoCaseStudies/videoCaseStudy-whyus-sideBg.svg'),
        photo1: require('Theme/images/videoCaseStudies/nivea/videoCaseStudy-nivea-whyus-photo-01.jpg'),
        photo2: require('Theme/images/videoCaseStudies/nivea/videoCaseStudy-nivea-whyus-photo-02.jpg'),
        photo3: require('Theme/images/videoCaseStudies/nivea/videoCaseStudy-nivea-whyus-photo-03.jpg'),
    },
    solution: {
        visible: true,
        title: 'THE SOLUTION',
        subtitle: 'The Foap Content Team prepared 129 creative briefs each with a specific goal and requirements to cover every aspect of NIVEA’s brand aesthetics. To simplify the process and make Foap a valued partner we divided the creative briefs into 6 content themes to drive excitement within our 3 MM Content Creators. With help of Foap’s Content Curators, we were able to build a robust library of fresh and new visuals that met NIVEA’s requirements and reinforced their brand storytelling. For some of the briefs, NIVEA’s products were sampled to numerous hand-picked creators ahead of their products hitting the stores.',
        video: {
            overlay: require('Theme/images/videoCaseStudies/nivea/videoCaseStudy-nivea-solution-videoOverlay.png'),
            poster: require('Theme/images/videoCaseStudies/nivea/videoCaseStudy-nivea-solution-videoPoster.jpg'),
            assets: [{
                src: 'https://videoscdn.foap.com/frontend-static-assets/case-studies/webm_w640-foap-case-study-nivea-1.webm',
                type: 'video/webm'
            }, {
                src: 'https://videoscdn.foap.com/frontend-static-assets/case-studies/mp4_w640-foap-case-study-nivea-1.mp4',
                type: 'video/mp4'
            }]
        }
    },
    results: {
        visible: true,
        title: 'CAMPAIGN<br />RESULTS',
        video: {
            poster: require('Theme/images/videoCaseStudies/nivea/videoCaseStudy-nivea-results-videoPoster.jpg'),
            assets: [{
                src: 'https://videoscdn.foap.com/frontend-static-assets/case-studies/webm_w640-foap-case-study-nivea-3.webm',
                type: 'video/webm'
            }, {
                src: 'https://videoscdn.foap.com/frontend-static-assets/case-studies/mp4_w640-foap-case-study-nivea-3.mp4',
                type: 'video/mp4'
            }]
        },
        textBlock: 'he newly created bank of NIVEA’s 25,933 curated visuals was collected and shared globally. In accordance with Foap’s content platform and full legal compliance of global, unlimited rights NIVEA centralized there messaging across countries. Their partnership with Foap simplified their need to keep their global brand messaging consistent throughout different regions. NIVEA partnered with Foap globally to be their go-to-partner in capturing natural looking visuals with strong storytelling power that would entice its brand philosophy and values.',
        testimony: {
            title: 'Client testimony:',
            content: '“Once our first Mission was launched, we were instantly captivated by the value and quality of on-brand content submitted by creators from all around the world, responding actively and creatively to our challenges. Power of Foap’s community seems to be limitless.” <br /><br /> Alisa Mueller, International Digital Content Manager',
        },
        list: [{
            styles: { color: '#4AD2FF' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-creators.svg'),
            title: '68K+',
            subtitle: 'Participants'
        }, {
            styles: { color: '#F5A623' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-image.svg'),
            title: '129…',
            subtitle: 'Missions launched, and counting…'
        }, {
            styles: { color: '#50E3C2' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-repair.svg'),
            title: '13',
            subtitle: 'Sampled Missions organised'
        }, {
            styles: { color: '#623CC9' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-video.svg'),
            title: '121',
            subtitle: 'Participants'
        }],
        photo1: require('Theme/images/videoCaseStudies/nivea/videoCaseStudy-nivea-results-photo-01.jpg'),
        photo2: require('Theme/images/videoCaseStudies/nivea/videoCaseStudy-nivea-results-photo-02.jpg'),
        bgSide: require('Theme/images/videoCaseStudies/videoCaseStudy-results-top.svg')
    },
    checkout: {
        visible: true
    }
};



// WEBPACK FOOTER //
// ./src/containers/global/VideoCaseStudy/data/nivea.js